export const userHasClaims = (claims: string[], userClaims: string[]): boolean => {
    for (let i = 0; i < claims.length; i++) {
        if (!userClaims.includes(claims[i])) {
            return false;
        }
    }
    return true;
}

export const userHasAtLeastOneClaim = (claims: string[], userClaims: string[]): boolean => {
  for (let i = 0; i < claims.length; i++) {
    if (userClaims.includes(claims[i])) {
      return true;
    }
  }
  return false;
}